/**
 * WhyVoleyTour - A sales-focused walkthrough explaining why Voley exists
 * and what makes it the communication infrastructure for insurance agencies.
 *
 * This tour is entirely modal-based — no navigation or element highlighting.
 */

import type { TourStep } from '../types';

export type WhyVoleyTourStepId = 'why_voley';

export const WHY_VOLEY_TOUR_STEPS: TourStep[] = [
  {
    id: 'why_voley',
    type: 'modal',
    title: '',
    content: '',
  },
];
